function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.64 39.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "livetype"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.64,8.43V7.51a13.39,13.39,0,0,0-.18-2,7.05,7.05,0,0,0-.62-1.9A6.55,6.55,0,0,0,116,.81a7.14,7.14,0,0,0-1.91-.63,13.39,13.39,0,0,0-2-.18H7.5a13.39,13.39,0,0,0-2,.18A6.74,6.74,0,0,0,3.6.81,6.07,6.07,0,0,0,2,2,6.07,6.07,0,0,0,.8,3.61a6.74,6.74,0,0,0-.63,1.9,12.18,12.18,0,0,0-.17,2v25a12.18,12.18,0,0,0,.17,2A6.8,6.8,0,0,0,.8,36.38,6,6,0,0,0,2,38,6.07,6.07,0,0,0,3.6,39.17a6.74,6.74,0,0,0,1.9.63,13.39,13.39,0,0,0,2,.18H112.12a13.39,13.39,0,0,0,2-.18,7.14,7.14,0,0,0,1.91-.63A6.07,6.07,0,0,0,117.65,38a6.68,6.68,0,0,0,1.18-1.61,7.12,7.12,0,0,0,.62-1.91,13.39,13.39,0,0,0,.18-2v-24Zm-.87,22v2a12.72,12.72,0,0,1-.17,1.85,5.83,5.83,0,0,1-.54,1.67,5.71,5.71,0,0,1-1,1.39,5.12,5.12,0,0,1-1.4,1A5.9,5.9,0,0,1,114,39a11.7,11.7,0,0,1-1.87.16H7.52A11.7,11.7,0,0,1,5.65,39,5.86,5.86,0,0,1,4,38.39a4.93,4.93,0,0,1-1.39-1,5.12,5.12,0,0,1-1-1.4A5.69,5.69,0,0,1,1,34.33a11.7,11.7,0,0,1-.16-1.87V7.54A11.7,11.7,0,0,1,1,5.67,5.6,5.6,0,0,1,1.58,4a5.12,5.12,0,0,1,1-1.4,5.58,5.58,0,0,1,1.4-1A5.69,5.69,0,0,1,5.64,1,11.83,11.83,0,0,1,7.52.88H112.11A12.85,12.85,0,0,1,114,1a6.18,6.18,0,0,1,1.67.55A5.48,5.48,0,0,1,118.05,4a6,6,0,0,1,.54,1.65,13.14,13.14,0,0,1,.17,1.88V30.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(34.9 14.34)",
    style: {
      isolation: "isolate",
      fontSize: 8,
      fill: "#fff",
      fontFamily: "ArialMT, Arial",
      letterSpacing: "0.0150146484375em"
    }
  }, "Disponible en"), /*#__PURE__*/React.createElement("path", {
    d: "M45.23,23.66H40V25.2h3.69A3.42,3.42,0,0,1,40,28.29a4.12,4.12,0,1,1,0-8.24,4,4,0,0,1,2.77,1.12l1.08-1.12A5.48,5.48,0,0,0,40,18.51a5.66,5.66,0,1,0,.08,11.32h0a5,5,0,0,0,5.25-4.74v-.41a5.55,5.55,0,0,0-.09-1Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.66,24a2.21,2.21,0,1,1-2.08,2.34v-.14a2.09,2.09,0,0,1,2-2.2Zm0-1.43a3.64,3.64,0,1,0,3.66,3.65,3.59,3.59,0,0,0-3.53-3.65Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.71,24a2.09,2.09,0,0,1,2,2.17v0a2.06,2.06,0,1,1-2-2.21Zm0-1.43a3.64,3.64,0,1,0,3.65,3.65,3.59,3.59,0,0,0-3.53-3.65Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,24a2,2,0,0,1,1.94,2.15v.06a2,2,0,0,1-1.78,2.2h-.22a2.07,2.07,0,0,1-2-2.14v-.05a2.1,2.1,0,0,1,2-2.23h.1Zm-.14-1.43a3.64,3.64,0,1,0,0,7.28,2.44,2.44,0,0,0,2-.88v.71a1.82,1.82,0,0,1-1.65,2h-.27a2,2,0,0,1-1.86-1.3l-1.4.59a3.51,3.51,0,0,0,3.28,2.14c1.94,0,3.42-1.22,3.42-3.79V22.77H67.53v.62a2.57,2.57,0,0,0-2-.84Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.22,24a1.44,1.44,0,0,1,1.35.78l-3.26,1.36A2,2,0,0,1,76.16,24Zm-.06-1.4a3.44,3.44,0,0,0-3.4,3.49v.15a3.52,3.52,0,0,0,3.39,3.65h.19a3.68,3.68,0,0,0,3-1.6l-1.26-.84a2.06,2.06,0,0,1-1.79,1,1.89,1.89,0,0,1-1.78-1.11l4.88-2-.25-.6a3.32,3.32,0,0,0-3-2.13Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.28,
    y: 18.88,
    width: 1.6,
    height: 10.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.77,
    y: 18.88,
    width: 1.6,
    height: 10.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.27,
    y: 18.88,
    width: 1.6,
    height: 10.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.27,18.88h3.88a3.43,3.43,0,0,1,3.41,3.42h0a3.43,3.43,0,0,1-3.41,3.42H83.27Zm1.6,1.61v3.63h2.28a1.82,1.82,0,0,0,0-3.63Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.21 33.1 109.85 22.54 108.1 22.54 103.46 33.1 105.21 33.1",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.72 30.69 102.15 22.54 103.9 22.54 106.37 28.16 105.72 28.16 105.72 30.69",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,29.61h1.6V25.75c.26-4-4.79-4.91-6.7-2l1.29.86c.94-1.63,3.6-1.25,3.77.49a7,7,0,0,0-2.45-.28A2.61,2.61,0,0,0,95,27a2.69,2.69,0,0,0,.55,2.07,3,3,0,0,0,3,.64,2.75,2.75,0,0,0,1.39-.93v.86Zm0-3.1a2.38,2.38,0,0,1-1.77,1.77c-1.86.51-2.32-2.5.44-2.09A7.58,7.58,0,0,1,100,26.51Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.21,30.75a1,1,0,0,0,.3-.14l13.82-7.56-3.28-3.27-10.84,11Zm14.73-8-3.42-3.41L26,15.86l4.7,2.56c1.16.63.57,1.42,0,1.73L26,22.72Zm-.62-7.2L11.51,8A1.34,1.34,0,0,0,11,7.84l11,11,3.27-3.32ZM10.22,8,21.58,19.31,10.28,30.75a1.42,1.42,0,0,1-.51-1.25c0-1.12-.1-19-.1-20.3A1.31,1.31,0,0,1,10.22,8Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayWhite);
export default __webpack_public_path__ + "static/media/google-play-white.f06d68e95f9cda2e133e997fc03b99fd.svg";
export { ForwardRef as ReactComponent };